/**
 * Classe pour manipuler localStorage
 */

export const STORAGE_KEYS = {
    RECENT_COLORS: '60ac5b9c',
    IMAGE_EDITOR_ZOOM: 'f83f43b3',
    TASK_FILTER_STATUS: '65b603be',
    HIDDEN_TRIAL_PERIOD_REMAINING_TIME: '1108930b',
    TASK_DISPLAY_MODE: '5bfad881',
    TASK_CALENDAR_PERIODICITY: 'de948cce'
};

export class Storage {

    /**
     * Retourne la valeur dans localStorage pour la clé en paramètre
     * @param string key
     * @param mixed defaultValue
     * @return string
     */
    get(key, defaultValue = null) {

        let response = localStorage.getItem(key) || defaultValue

        try {
            response = JSON.parse(response);
        } catch(e) {

        }

        return response;
    };

    /**
     * Modifie la valeur de la clé dans localStorage
     * @param string key
     * @param mixed value
     * @return void
     */
    set(key, value) {
        localStorage.setItem(key, JSON.stringify(value));
    };

    /**
     * Supprime la clé en paramètre
     * @param string key
     * @return void
     */
    delete(key) {
        localStorage.removeItem(key);
    };

    /**
     * Supprime toutes les clés
     * @return void
     */
    clear() {
        Object.values(STORAGE_KEYS).forEach((key) => {
            localStorage.removeItem(key);
        });
    };

};

let storageInstance = null;

export default function() {
    if(storageInstance === null) {
        storageInstance = new Storage();
    }
    return storageInstance;
}
